import React from 'react';
import { ButtonBorderedKVBase, SignUpHeader } from '@/presentation/components';
import Styles from './stripe-payment-result-styles.scss';
import AuthFooter from '@/presentation/components/auth-footer/auth-footer';
import { IconPaymentSuccess } from '@/presentation/components/icons';
import { useNavigate } from 'react-router';
import Warning4 from '@/presentation/components/icons/warning4';
import { useSearchParams } from 'react-router-dom';
import MacOsIcon from '@/presentation/components/img/macOS-icon';
import WindowsOsIcon from '@/presentation/components/img/windosOS-icon';
import { isMobile } from 'mobile-device-detect';
import usePartner from '@/presentation/hooks/use-partner';
const StripePaymentResult = ({ test }) => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    // Query params
    const flagClientAsClearSubscriptionFreeTrial = searchParams.get('flagClientAsClearSubscriptionFreeTrial');
    const redirectToAccount = flagClientAsClearSubscriptionFreeTrial === 'true';
    const { rootPath } = usePartner({});
    return (React.createElement("div", { className: Styles.wrap },
        React.createElement(SignUpHeader, { hideSignInButton: true }),
        React.createElement("div", { className: Styles.content },
            React.createElement("div", { className: Styles.mainWrap },
                React.createElement(IconPaymentSuccess, null),
                React.createElement("div", { className: Styles.title1 }, `Congrats! You're All Done!`),
                React.createElement("div", { className: Styles.title2 }, "Your Account is Ready"),
                redirectToAccount ? (React.createElement("div", { className: Styles.title3 }, "Now you can go back to your account.")) : (React.createElement("div", { className: Styles.title3 }, "Now you can login with your email and password.")),
                React.createElement("div", { className: Styles.warning },
                    React.createElement("div", null,
                        React.createElement(Warning4, null)),
                    React.createElement("div", { className: Styles.text },
                        React.createElement("b", null,
                            "Make sure your students ",
                            `don't`,
                            " miss out"),
                        " remind them to check their email for their separate student login details to access their student portal!")),
                !isMobile ? (React.createElement("div", { className: Styles.btn }, redirectToAccount ? (React.createElement(ButtonBorderedKVBase, { type: "button", onClick: () => navigate('/school-dashboard') }, "Go back to your account")) : (React.createElement(ButtonBorderedKVBase, { type: "button", onClick: () => navigate(`${rootPath}login`) }, "Go to login")))) : (React.createElement("div", { className: Styles.toContinueContainer },
                    "To continue using our e-learning platform, please log in via a Mac or PC",
                    React.createElement("div", { className: Styles.osIcons },
                        React.createElement(MacOsIcon, null),
                        React.createElement(WindowsOsIcon, null)))))),
        React.createElement(AuthFooter, { leftInner: false })));
};
export default StripePaymentResult;
